import React from 'react';
import _ from 'lodash';

import {
  BaseWidget,
  ChatMessageList,
  SendChatMessageModal
} from 'modules';

import * as dataService from './dataService';
import { Button } from '@mui/material';
import { modalUtil } from 'iron-forge-react-modules';



export interface IProps {
  orderId?: string;
  returnAuthorizationId?: string;
}

export const FC: React.FC<IProps> = props => {
  const tuple = dataService.useQuery(props.orderId ?? props.returnAuthorizationId ?? '', !_.isNil(props.orderId));
  const {
    modalType2IsOpen,
    setModalIsOpen
  } = modalUtil.useModalTrackers([
    'sendMessage'
  ]);



  function handleClickSendMessage() {
    setModalIsOpen('sendMessage', true);
  }

  function handleCloseSendChatMessageModal() {
    setModalIsOpen('sendMessage', false);
  }



  return (
    <>
      <BaseWidget.FC
        title="Messages"
        elAction={(
          <Button
            variant="contained"
            onClick={handleClickSendMessage}>
            Send Message
          </Button>
        )}>
        <ChatMessageList.FC
          messages={tuple.data.chatMessages} />
      </BaseWidget.FC>

      {modalType2IsOpen.sendMessage && (
        <SendChatMessageModal.FC
          isCustomer
          orderId={props.orderId}
          returnAuthorizationId={props.returnAuthorizationId}
          onClose={handleCloseSendChatMessageModal} />
      )}
    </>
  );
};
